import { render, staticRenderFns } from "./ShippingLabel.vue?vue&type=template&id=3c603951"
import script from "./ShippingLabel.vue?vue&type=script&lang=js"
export * from "./ShippingLabel.vue?vue&type=script&lang=js"
import style0 from "./ShippingLabel.vue?vue&type=style&index=0&id=3c603951&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports